<template>
  <button class="menu-button" @click="$emit('click')">
    <span class="tri-bars">
      <span class="tri-bar"></span>
      <span class="tri-bar"></span>
      <span class="tri-bar"></span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'MenuButton',
}
</script>

<style lang="scss" scoped>
.menu-button {
  border-radius: 3px;
  outline: none;
  background: white;
  border: 1px solid black;
  padding: 5px;
}

$dim: 20px;
.tri-bars {
  height: $dim;
  width: $dim + 4px;
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

.tri-bar {
  height: 2px;
  width: 100%;
  background: black;
}
</style>
